import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';

export const removeAppUserFromOrganisationRequest = (state: Draft<IAppUserState>, { type }: PayloadAction<{ appUserId: string, organisationId: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const removeAppUserFromOrganisationSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{ appUserId: string }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);

  const entries = { ...state.entries };
  entries[payload.appUserId] && delete entries[payload.appUserId];

  state.entries = entries;
  state.maxCount = state.maxCount - 1;
};

export const removeAppUserFromOrganisationFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
